import BaseAPI from './base'
/**
 * API xử lý học sinh
 */
class StudentAPI extends BaseAPI {}

export default new StudentAPI('v1/students', 'Student')
